//
//
//
//
//
//
//
//
//
//
//

	export default {
		props: ['proge'],
		data () {
			return{
				progessWidth:{
					left:''
				},
				propsWidth:{
					width:''
				},
				num:''
			}
		},
		methods: {
			progess () {
				// console.log('**********************',this.$refs.all.clientWidth)
				// console.log('**********************//////////',this.$refs.progessWidth.clientWidth)

				let distance
				if(	parseFloat(this.proge)>=100){
					this.num='完成'
					this.proge=100
					this.propsWidth.width ='100%'
					this.progessWidth.right = 0
					this.progessWidth.left = 'inherit'
					this.progessWidth.marginRight = '0'
				}else{
					if(parseFloat(this.proge)>=50){
						this.propsWidth.width = this.proge + '%'
						this.progessWidth.right = (100-this.proge)+'%'
						let rightDistance = (100-this.proge)*document.body.clientWidth/100
						if(rightDistance<this.$refs.progessWidth.clientWidth){
							this.progessWidth.marginRight = '0'
						}else{
							this.progessWidth.marginRight = '-'+this.$refs.progessWidth.clientWidth/2 +'px'
						}
					}else{
						this.propsWidth.width = this.proge + '%'
						this.progessWidth.marginRight = '0'
						this.progessWidth.left = this.proge+'%'
						let leftDistance = this.proge*document.body.clientWidth/100
						if(leftDistance<this.$refs.progessWidth.clientWidth){
							this.progessWidth.marginLeft = '0'
						}else{
							this.progessWidth.marginLeft = '-'+this.$refs.progessWidth.clientWidth/2 +'px'
						}
					}
					// distance=(this.$refs.all.clientWidth- this.$refs.progessWidth.clientWidth)/100
					// this.num=this.proge+'%'

				}
				// this.progessWidth.left = (this.proge * distance) - 15 + 'px'
				// this.propsWidth.width = (this.proge * distance) + 'px'

			}
		},
		computed:{

		},
		watch:{
			proge(n,v){
				this.num = this.proge+'%'
				this.progess()
			}
		},
		mounted (){
			this.num = this.proge+'%'
			this.progess()
		}
	}



// WEBPACK FOOTER //
// ./src/components/prog/Progresshelp.vue